<div class="container-fluid">
  @if (showBack()) {
    <button mat-icon-button matTooltip="Back" (click)="goBack()">
      <mat-icon svgIcon="arrow-left" />
    </button>

    <mat-divider class="divider" [vertical]="true" />
  }

  <ng-content />
</div>